/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-adpod-asset-list-component.ts
 *
 * Created by randysorensen on 9/19/18.
 */

function PackageMediaAdPodAssetListController (
    this: JS5Object,
    _: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.getAdPod = (): JS5Object => {
        return _.first(PackageMediaService.getAssetList('AdPod'));
    };

    this.isEnabled = () => {
        return !this.getAdPod() && !!PackageMediaService.hasMainVideo();
    };

    this.getIngestPercent = () => {
        return parseInt(_.get(this.getAdPod(), 'ingestInfo.progress', -1));
    };

    this.addNewAdPod = () => {
        PackageMediaService.packageMediaData.assets.push({
            type: 'AdPod',
            adPodAcceptProfile: PackageMediaService.packageMediaData.adPodAcceptProfile
        });
        PackageUtilService.editorForm.$setDirty();
    };

    this.removeAdPod = () => {
        _.pull(PackageMediaService.packageMediaData.assets, this.getAdPod());
        PackageUtilService.editorForm.$setDirty();
    };


    // =================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.adPodAcceptProfile = PackageMediaService.packageMediaData.adPodAcceptProfile;
    }
}

angular.module('prism-ui.package').component('packageMediaAdPodAssetList', {
    controller: PackageMediaAdPodAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/adPodAssetList/package-media-adpod-asset-list-template.html',
    bindings: {
    }
});
